// extracted by mini-css-extract-plugin
module.exports = {"DisqusComments":"DisqusComments_DisqusComments__3F393"};